import {
  ActivityQuery,
  AuthConfig,
  createRecordFromKey,
  EndpointActivity,
  greaterThanToday,
  Probe,
  parseDate,
  queries,
} from "@theprelude/core";
import { createQuery } from "@/lib/create-query";

export type Host = Probe & {
  performance?: number;
  isActive: boolean | null;
  policy_name: string | undefined;
};

const getIsActive = (beacon: string) => {
  return !greaterThanToday(parseDate(beacon), 1);
};

export function getEndpointData(
  endpoints: Probe[],
  endpointActivity: EndpointActivity[],
): Host[] {
  const endpointActivityById = createRecordFromKey(
    endpointActivity,
    "id",
    "protected",
  );
  return endpoints.map((endpoint) => {
    return {
      ...endpoint,
      performance: endpointActivityById[endpoint.endpoint_id],
      isActive: endpoint.last_seen ? getIsActive(endpoint.last_seen) : null,
      policy_name: endpoint.policy_name ?? undefined,
    };
  });
}

export const endpointsQuery = (authConfig: AuthConfig, query?: ActivityQuery) =>
  createQuery({
    queries: [
      queries.detect.endpoints(authConfig, 90),
      queries.detect.activity.endpoints(authConfig, query),
    ],
    queryFn: getEndpointData,
  });
